<template>
  <v-flex d-flex class="date-picker">
    <v-flex d-flex  class="date-picker-title" v-if="title != ''">
      <span style="font-size: 1.2rem">{{ $tf(title) }}</span>
    </v-flex>
    <v-layout row wrap>
      <v-flex md4 v-if="selectableItems">
        <v-select
          v-model="select"
          :items="selectableItems"
          :label="label"
          item-text="text"
          item-value="value"
          light
          clearable
        >
          <template slot="item" slot-scope="{item}">
            {{ $tf(item.text) }}
          </template>
          <template slot="selection" slot-scope="{ item }">
            <span class="d-flex justify-center capitalize" style="width: 100%; 'text-transform': 'capitalize';
                  color: 'primary'">
              {{ $tf(item.text) }}
            </span>
          </template>
        </v-select>
      </v-flex>
      <v-flex md8>
        <v-layout row wrap>
          <v-flex md6 sm6 xs12>
            <v-menu
              ref="startMenu"
              v-model="startMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
              light
            >
              <v-text-field
                v-model="startDateFormatted"
                :label="$tf('startDate')"
                prepend-icon="event"
                readonly
                light
                clearable
                slot="activator"
                @input="clear('startDate')"
              ></v-text-field>
              <v-date-picker
                v-model="startDate"
                no-title
                light
                first-day-of-week="1"
                :locale="this.$store.state.session.locale"
                :max="endDate"
                @input="setInput()"
              />
            </v-menu>
          </v-flex>
          <v-flex md6 sm6 xs12>
            <v-menu
              ref="endMenu"
              v-model="endMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
              light
            >
              <v-text-field
                v-model="endDateFormatted"
                :label="$tf('endDate')"
                prepend-icon="event"
                readonly
                light
                clearable
                slot="activator"
                @input="clear('endDate')"
              ></v-text-field>
              <v-date-picker
                v-model="endDate"
                no-title
                light
                first-day-of-week="1"
                :locale="this.$store.state.session.locale"
                :min="startDate"
                @input="setInput()"
              />
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    selectableItems: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      startDate: '',
      endDate: '',
      startMenu: false,
      endMenu: false,
      select: ''
    }
  },
  watch: {
    value (newValue) {
      if (newValue && newValue.type) {
        this.select = newValue.type
        this.startDate = newValue.start
        this.endDate = newValue.end
      }
    }
  },
  mounted () {
    if (this.value && this.value.type) {
      this.select = this.value.type
      this.startDate = this.value.start
      this.endDate = this.value.end
    }
  },
  computed: {
    startDateFormatted: {
      get () {
        return this.startDate.split('-').reverse().join('-')
      },
      set (value) {
        return value
      }
    },
    endDateFormatted: {
      get () {
        return this.endDate.split('-').reverse().join('-')
      },
      set (value) {
        return value
      }
    }
  },
  methods: {
    setInput () {
      this.startMenu = false
      this.endMenu = false
      if (this.startDate !== '' && this.endDate !== '') {
        if (this.select === '') {
          this.select = this.selectableItems[0].value
        }
        this.$emit('input', { start: this.startDate, end: this.endDate, type: this.select })
      }
    },
    clear (key) {
      this[key] = ''
      if (this.startDate === '' && this.endDate === '') {
        this.$emit('input', null)
      }
    }
  }
}
</script>

<style>
  .date-picker-title {
    min-width: 60px;
  }
  .date-picker {
    align-items: baseline !important;
  }
</style>

<style scoped>
  @media only screen and (max-width: 600px) {
    .menu {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/DatePicker.vue